export default __webpack_public_path__ + "static/media/img-cadey-parent.9966994b.jpg";